export const environment = {
  production: false,
  config: {
    api: '',
  },
  version: '2.5.0-SNAPSHOT.138',
};
